var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import ChildComponent from '../ChildComponent';
export var StyledDivContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  background-color: ", ";\n  ", "\n"], ["\n  ", ";\n  color: ",
    ";\n  background-color: ",
    ";\n  ",
    "\n"])), function (props) { return ({ ...props.componentStyle }); }, function (_a) {
    var _b;
    var componentStyle = _a.componentStyle, fontColor = _a.fontColor;
    return (_b = fontColor !== null && fontColor !== void 0 ? fontColor : componentStyle.color) !== null && _b !== void 0 ? _b : 'inherit';
}, function (_a) {
    var _b;
    var componentStyle = _a.componentStyle, backgroundColor = _a.backgroundColor;
    return (_b = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : componentStyle.backgroundColor) !== null && _b !== void 0 ? _b : 'inherit';
}, function (_a) {
    var blinkingColor2 = _a.blinkingColor2, blinkingColor1 = _a.blinkingColor1, blinkingTime = _a.blinkingTime;
    return blinkingTime &&
        blinkingColor1 &&
        blinkingColor2 && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      animation: ", "\n        ", "s infinite;\n    "], ["\n      animation: ", "\n        ", "s infinite;\n    "])), blinkingAnimation(blinkingColor1, blinkingColor2), blinkingTime);
});
export var blinkingAnimation = function (color1, color2) { return keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    0% {\n        background-color: ", ";\n    }\n    50% {\n        background-color: ", ";\n    }\n    100% {\n        background-color: ", ";\n    }\n"], ["\n    0% {\n        background-color: ", ";\n    }\n    50% {\n        background-color: ", ";\n    }\n    100% {\n        background-color: ", ";\n    }\n"])), color1, color2, color1); };
export function GridComponent(props) {
    return (React.createElement(StyledDivContainer, __assign({}, props),
        React.createElement(ChildComponent, { children: props.children })));
}
export var StyledText = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return ({ ...props.componentStyle }); });
export var labelTransform = function (label) {
    var lines = label.replace(/\n/g, '<br/>');
    return { __html: lines };
};
export function TextComponent(props) {
    return (React.createElement(StyledText, __assign({}, props, { dangerouslySetInnerHTML: labelTransform(props.label) })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Grid.js.map